import React from 'react';

import  Seminar2025  from 'views/Seminar2025';

const BlogNewsroomPage = () => {

return <Seminar2025/>
};

export default BlogNewsroomPage;